/** Primary breakpoint: stack layouts below this, multi-column at/above. */
export const MOBILE_LAYOUT_LG = 'lg';

/** Game page uses xl for side-by-side desktop band. */
export const MOBILE_LAYOUT_XL = 'xl';

/** Safe-area padding for notched phones / home indicator. */
export const SAFE_AREA_BOTTOM = 'env(safe-area-inset-bottom, 0px)';
export const SAFE_AREA_TOP = 'env(safe-area-inset-top, 0px)';

/** Prefer dynamic viewport height where full-screen shells are used. */
export const VIEWPORT_MIN_H = 'min(100dvh, 100vh)';

/** Desktop profile/scores column min-height (uses dynamic viewport). */
export const PROFILE_SCROLL_COLUMN_MIN_H =
  'min(calc(62dvh * 1.3), calc(1.3 * (min(100dvh, 100vh) - 240px)))';

/** Chakra responsive padding for modal headers (notch-aware on phones). */
export const MODAL_HEADER_PT = {
  base: `calc(2.5rem + ${SAFE_AREA_TOP})`,
  md: 6,
} as const;

/** Chakra responsive padding for modal footers (home indicator). */
export const MODAL_FOOTER_PB = {
  base: `calc(1rem + ${SAFE_AREA_BOTTOM})`,
  md: 4,
} as const;

/** Chakra `ModalContent` props for edge-to-edge mobile modals. */
export const MOBILE_FULL_SCREEN_MODAL_CONTENT_PROPS = {
  maxW: '100%',
  maxH: '100%',
  minH: VIEWPORT_MIN_H,
  m: 0,
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
} as const;

/** Desktop scrollable modal shell (pairs with `SCROLLABLE_MODAL_BODY_PROPS`). */
export const DESKTOP_SCROLLABLE_MODAL_CONTENT_PROPS = {
  display: 'flex',
  flexDirection: 'column',
  maxH: '92vh',
} as const;

/** Scrollable modal body — flex child with overflow for `scrollBehavior="inside"`. */
export const SCROLLABLE_MODAL_BODY_PROPS = {
  flex: 1,
  minH: 0,
  overflowY: 'auto' as const,
};
